export default "__VITE_ASSET__Cu9sEuY6__"